export const Organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://loadsmart.com/#organization',
  name: 'Loadsmart',
  url: 'https://loadsmart.com/',
  description:
    'Loadsmart connects an AI-native TMS logistics platform with dock scheduling, gate and yard software, backed by freight brokerage and managed transportation services.',
  logo: {
    '@type': 'ImageObject',
    url: 'https://loadsmart.com/images/logos/loadsmart-green.png',
    width: 320,
    height: 148,
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '200 W. Jackson Blvd Suite 1600',
    addressLocality: 'Chicago',
    addressRegion: 'IL',
    postalCode: '60606',
    addressCountry: 'US',
  },
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+1-646-887-6278',
      contactType: 'sales',
      areaServed: 'US',
      availableLanguage: ['English', 'Spanish', 'Portuguese'],
    },
  ],
  sameAs: [
    'https://www.linkedin.com/company/loadsmart',
    'https://www.instagram.com/loadsmart',
    'https://twitter.com/LoadSmartUS',
    'https://www.youtube.com/channel/UCN-pkKcoMargmyL0Br3-H5w',
    'https://www.facebook.com/loadsmartUS',
  ],
};

export const SoftwareApplication = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Loadsmart AI',
  url: 'https://loadsmart.com/ai/',
  applicationCategory: 'BusinessApplication',
  applicationSubCategory: 'Logistics Management',
  operatingSystem: 'Web-based',
  provider: { '@id': 'https://loadsmart.com/#organization' },
  description:
    'Loadsmart AI is logistics AI for freight and warehouse operations, executing tasks end to end inside a shipper’s existing system of record: quoting, tendering, Opendock dock scheduling, document collection, load audits and claims, with Loadsmart Freight Experts resolving exceptions.',
  featureList: [
    'Document collection and filing',
    'Tracking and status updates',
    'Tender failure recovery and re-tendering',
    'Proactive load audits',
    'Claims processing',
    'Opendock appointment scheduling and rescheduling',
    'Purchase order follow-up',
    'Detention handling',
    'Warehouse customer service',
    'Dock schedule management',
    'Yard task orchestration',
  ],
};

export const JsonLd = ({ data }) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};
